import axios from 'axios';

const state = {
  alert: null,
  collapsed: false,
  collapsedDate: null,
};

const getters = {

};

const actions = {
  async getAlert({ commit, state: st }) {
    const response = await axios.get(`${process.env.VUE_APP_CRISIS_API}getCrisis`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
      },
    });

    if (response.data.length === 0) {
      commit('resetAlert');
    } else {
      response.data.forEach((c) => {
        if (!st.collapsedDate || new Date(c.updated_at) > new Date(st.collapsedDate)) {
          commit('setNewAlert', c);
        }
      });
    }
  },
  collapseAlert({ commit }, collapsed) {
    commit('collapseAlert', collapsed);
  },
};

const mutations = {
  resetAlert(st) {
    st.alert = null;
  },
  setNewAlert(st, alert) {
    st.collapsed = false;
    st.alert = alert;
  },
  collapseAlert(st, collapsed) {
    st.collapsed = collapsed;
    st.collapsedDate = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
